import {Component, Input, ViewChild} from '@angular/core';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';

@Component({
  selector: 'page-history',
  templateUrl: 'history.html',
  styleUrls: ['./history.scss']
})
export class HistoryPage {
  @Input() showHeader = true;
  @ViewChild('historyComponent') historyComponent:any;

  constructor(public patientDataProvider: PatientDataProvider) {
  }

  async updateHistoryDesc(newData) {
    const idx = newData.index;
    delete newData.index;
    this.patientDataProvider.activePatientData.history[idx] = newData;
    this.patientDataProvider.update(this.patientDataProvider.activePatientData).subscribe((data:any)=>{
      this.patientDataProvider.activePatientData._id = data.data.data.data.id;
      this.patientDataProvider.activePatientData._rev = data.data.data.data.rev;
      this.historyComponent.data.refresh();
    }, (err)=>{});
  }

}
